import { useCallback } from 'react';
import {
    includesSettingsCountryPage,
    includesSettingsProfilesPage,
    isAnalysisPage,
    isDashboardOverviewPage,
    isDashboardPage,
    isDashboardPowerPlantOverviewPage,
    isDashboardPowerPlantEquipmentComparePage,
    isDashboardPowerPlantEquipmentDetailsPage,
    isDashboardPowerPlantSkidEquipmentComparePage,
    isDashboardPowerPlantSkidEquipmentDetailsPage,
    isDashboardPowerPlantSkidEquipmentSimplePage,
    isDashboardPowerPlantSkidEquipmentPage,
    isDashboardPowerPlantSkidOverviewPage,
    isHelpPage,
    isIncludesAnalysisHomePage,
    isReportsPage,
    isSettingsCountryPage,
    isSettingsPage,
    isSettingsProfilesPage, isDashboardPowerPlantPage,
    isDashboardOverviewAlarmsPage,
    isDashboardOverviewMapPage,
    isDashboardOverviewSynopticPage,
    isCommunicationPage,
    isDashboardPowerPlantSkidChartsPage,
    isDashboardPowerPlantSkidLayoutPage,
    isDashboardPowerPlantSkidAlarmsPage,
    isDashboardPowerPlantLayoutPage,
    isDashboardPowerPlantAlarmsPage,
    isDashboardPowerPlantChartsPage,
    isDashboardPowerPlantTrackersPage,
    isDashboardPowerPlantInvertersPage,
    isDashboardPowerPlantBatteriesPage,
    isDashboardOverviewPerformancePage,
    isDashboardOverviewActivePowerPage,
    isDashboardOverviewChartsPage
} from "../../Utils/RouteUtils";
import {
    setLayoutHeaderMenuClosed,
    setLayoutHeaderMenuOpen,
    setLayoutSubHeaderMenuClosed,
    setLayoutSubHeaderMenuOpen,
    showFullMenu,
} from "../Reducers/LayoutReducer";
import {
    hideDashboardHeaderMenu,
    hideDashboardSubHeaderMenu,
    setDashboardHeaderMenuButtons,
    showDashboardHeaderMenu,
    showDashboardSubHeaderMenu
} from "../../Modules/Dashboard/DashboardMenuReducer";
import {setCountryHeaderMenuButtons, showCountryHeaderMenu} from "../../Modules/Settings/Country/CountryMenuReducer";
import {
    setProfilesHeaderMenuButtons,
    showProfilesHeaderMenu
} from "../../Modules/Settings/Profiles/ProfilesMenuReducer";
import {useAppDispatch, useAppSelector} from "../Hooks";

export default function useAppLayoutSetup() {
    const isAuthenticated = useAppSelector((state: any) => state.authentication.isAuthenticated);
    const dispatch = useAppDispatch();

    const setup = useCallback(() => {
        if (isAuthenticated) {

            if (isDashboardPage()) {
                dispatch(setLayoutHeaderMenuOpen());
                dispatch(showDashboardHeaderMenu());

                if(isDashboardOverviewPage() ||
                   isDashboardOverviewSynopticPage() ||
                   isDashboardOverviewMapPage() ||
                   isDashboardOverviewAlarmsPage() ||
                   isDashboardOverviewPerformancePage() ||
                   isDashboardOverviewActivePowerPage() ||
                   isDashboardOverviewChartsPage()

                ) {
                    dispatch(setDashboardHeaderMenuButtons({
                            chartsButton: true,
                            layoutButton: false,
                            mapButton: true,
                            equipmentsButton: false,
                            alarmsButton: true,
                            synopticButton: true,
                            performanceButton: true,
                            activePowerButton: true,
                            trackersButton: false,
                            invertersButton: false,
                            unavailabilityButton: true
                        }
                    ));
                    dispatch(hideDashboardSubHeaderMenu());
                }

                if(isDashboardPowerPlantOverviewPage() ||
                    isDashboardPowerPlantLayoutPage()  ||
                    isDashboardPowerPlantAlarmsPage()  ||
                    isDashboardPowerPlantChartsPage()  ||
                    isDashboardPowerPlantTrackersPage() ||
                    isDashboardPowerPlantInvertersPage() ||
                    isDashboardPowerPlantBatteriesPage()
                ) {
                    dispatch(setDashboardHeaderMenuButtons({
                            chartsButton: true,
                            layoutButton: true,
                            mapButton: true,
                            equipmentsButton: false,
                            alarmsButton: true,
                            trackersButton: true,
                            invertersButton: true,
                            synopticButton: false,
                            batteriesButton: true,
                        }
                    ));
                }

                if(isDashboardPowerPlantSkidOverviewPage() ||
                    isDashboardPowerPlantSkidChartsPage() ||
                    isDashboardPowerPlantSkidAlarmsPage() ||
                    isDashboardPowerPlantSkidLayoutPage()
                ) {
                    dispatch(hideDashboardSubHeaderMenu());
                    dispatch(setDashboardHeaderMenuButtons({
                            chartsButton: true,
                            layoutButton: true,
                            mapButton: false,
                            equipmentsButton: true,
                            alarmsButton: true,
                            trackersButton: false,
                            invertersButton: false,
                            synopticButton: false
                        }
                    ));
                }

                if(isDashboardPowerPlantSkidEquipmentPage()){
                    dispatch(setLayoutSubHeaderMenuOpen());
                    dispatch(showDashboardSubHeaderMenu());
                    dispatch(setDashboardHeaderMenuButtons({
                            chartsButton: true,
                            layoutButton: true,
                            mapButton: false,
                            equipmentsButton: true,
                            alarmsButton: true,
                            trackersButton: false,
                            invertersButton: false,
                            synopticButton: false,
                        }
                    ));
                }

                if(!isDashboardPowerPlantSkidEquipmentPage()){
                    dispatch(setLayoutSubHeaderMenuClosed());
                    dispatch(hideDashboardSubHeaderMenu());
                }

                if(isDashboardPowerPlantSkidEquipmentDetailsPage() || isDashboardPowerPlantSkidEquipmentComparePage()){
                    dispatch(hideDashboardHeaderMenu());
                    dispatch(hideDashboardSubHeaderMenu());
                }

                if(isDashboardPowerPlantEquipmentDetailsPage() || isDashboardPowerPlantEquipmentComparePage()){
                    dispatch(hideDashboardHeaderMenu());
                    dispatch(hideDashboardSubHeaderMenu());
                }

                if(isDashboardPowerPlantSkidEquipmentSimplePage()){
                    dispatch(setDashboardHeaderMenuButtons({
                            chartsButton: true,
                            layoutButton: true,
                            mapButton: false,
                            equipmentsButton: false,
                            alarmsButton: true,
                            trackersButton: true,
                            invertersButton: false,
                            synopticButton: false,
                        }
                    ));
                }
            }

            if(isIncludesAnalysisHomePage()) {
                dispatch(hideDashboardSubHeaderMenu());
                dispatch(hideDashboardHeaderMenu());
                dispatch(setLayoutSubHeaderMenuClosed());
                dispatch(setLayoutHeaderMenuClosed());
            }

            if(isAnalysisPage()) {
                dispatch(hideDashboardSubHeaderMenu());
                dispatch(hideDashboardHeaderMenu());
                dispatch(setLayoutSubHeaderMenuClosed());
                dispatch(setLayoutHeaderMenuClosed());
            }

            if(isSettingsPage()){

                dispatch(hideDashboardSubHeaderMenu());
                dispatch(hideDashboardHeaderMenu());
                dispatch(setLayoutSubHeaderMenuClosed());
                dispatch(setLayoutHeaderMenuClosed());

                if(isSettingsCountryPage() || includesSettingsCountryPage()) {
                    dispatch(setLayoutHeaderMenuOpen());
                    dispatch(showCountryHeaderMenu());
                    dispatch(setCountryHeaderMenuButtons({
                            newRecord: true,
                        }
                    ));
                }

                if(isSettingsProfilesPage() || includesSettingsProfilesPage()) {
                    dispatch(setLayoutHeaderMenuOpen());
                    dispatch(showProfilesHeaderMenu());
                    dispatch(setProfilesHeaderMenuButtons({
                            newRecord: true,
                        }
                    ));
                }
            }

            if(isReportsPage()) {
                dispatch(hideDashboardSubHeaderMenu());
                dispatch(hideDashboardHeaderMenu());
                dispatch(setLayoutSubHeaderMenuClosed());
                dispatch(setLayoutHeaderMenuClosed());
                dispatch(showFullMenu());
            }

            if(isCommunicationPage()) {
                dispatch(hideDashboardSubHeaderMenu());
                dispatch(hideDashboardHeaderMenu());
                dispatch(setLayoutSubHeaderMenuClosed());
                dispatch(setLayoutHeaderMenuClosed());
            }

            if(isHelpPage()) {
                dispatch(hideDashboardSubHeaderMenu());
                dispatch(hideDashboardHeaderMenu());
                dispatch(setLayoutSubHeaderMenuClosed());
                dispatch(setLayoutHeaderMenuClosed());
            }

        }
    }, [dispatch, isAuthenticated]);

    return setup;
}
